const notChangeStepDealCauseJoin = {
    title: 'Ошибка смены этапа',
    description:
        'Нельзя менять этап у успешной сделки, если на неё <b>создано подключение</b>, которое находится в процессе. Если это необходимо — сначала <b>удалите приглашение</b>',
    buttonText: 'Понятно',
    mode: 'denied',
} as const;

export default notChangeStepDealCauseJoin;
